
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Can I use CSS frameworks?`}</h2>
    <p>{`Integrating an existing CSS framework with styled-components is really easy! You can use its existing class names alongside your components.`}</p>
    <p>{`For example, imagine you have an existing app with two classes you want to use again: `}<inlineCode parentName="p">{`.small`}</inlineCode>{` and `}<inlineCode parentName="p">{`.big`}</inlineCode>{`. If you want the class to always be attached to the component, you should use `}<a parentName="p" {...{
        "href": "/docs/api#attrs"
      }}>{`the `}<inlineCode parentName="a">{`attrs`}</inlineCode>{` method`}</a>{` to attach it. If you want to attach it only in some cases you can use the `}<inlineCode parentName="p">{`className`}</inlineCode>{` props like you always have!`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-react"
      }}>{`// Using .attrs, we attach the .small class to every <Button />
const Button = styled.button.attrs(props => ({
  className: "small",
}))\`
  background: black;
  color: white;
  cursor: pointer;
  margin: 1em;
  padding: 0.25em 1em;
  border: 2px solid black;
  border-radius: 3px;
\`;

render(
  <div>
    <Button>Styled Components</Button>
    {/* Here we attach the class .big to this specific instance of the Button */}
    <Button className="big">The new way to style components!</Button>
  </div>
);
`}</code></pre>
    <p>{`If the framework has a bunch of raw global CSS that needs to be included on the page, you can add it using the `}<a parentName="p" {...{
        "href": "/docs/api#createglobalstyle"
      }}><inlineCode parentName="a">{`createGlobalStyle`}</inlineCode>{` API`}</a>{`. This is also useful for things like CSS resets.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Note that for styled-components v3 and below, the previous API for global styles was `}<a parentName="p" {...{
          "href": "/docs/api#injectglobal"
        }}><inlineCode parentName="a">{`injectGlobal`}</inlineCode></a>{`.`}</p>
    </blockquote>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;